import request from "./request";

const MessagesService = {
  sendMessage: async (messagesDto: MessagesDto): Promise<any> => {
    return await request({
      method: "post",
      baseURL: `${process.env.REACT_APP_API_URL}/messages`,
      data: messagesDto,
    });
  },
};

export { MessagesService };
